export const commonError = {
  stage: [
    'Ошибка на сервере. Попробуйте отсканировать код еще раз или обратитесь в техническую поддержку',
  ],
}
